/**
 * Usage Configuration for Labels
 */

import { supabase } from '../../../../../supabaseClient';

export const usageLabelConfig = {
  type: 'labels',
  displayName: 'Labels',
  singularName: 'Label',
  itemIdField: 'label_id',
  itemNameField: 'name',
  
  // Database tables
  inventoryTable: 'label_inventory',
  itemsTable: 'label_inventory_items',
  transactionsTable: 'label_transactions',
  
  // Get available inventory items for a location
  getInventoryItems: async (companyId, itemId, locationId) => {
    const { data, error } = await supabase
      .from('label_inventory_items')
      .select('*')
      .eq('company_id', companyId)
      .eq('label_id', itemId)
      .eq('location_id', locationId)
      .eq('is_active', true)
      .gt('current_quantity', 0)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },
  
  // Execute usage transaction
  executeUsage: async (companyId, usageData) => {
    const { locationId, usages, notes } = usageData;
    
    // Process each usage item
    for (const usage of usages) {
      const { itemId, lotId, quantity, lot_number, batch_number } = usage;
      
      // Only create transaction - DB triggers will handle inventory updates
      const { error: txError } = await supabase
        .from('label_transactions')
        .insert([{
          company_id: companyId,
          label_id: itemId,
          transaction_type: 'usage',
          quantity: -Math.abs(quantity), // Negative for usage
          location_id: locationId,
          lot_number: lot_number,
          batch_number: batch_number,
          transaction_date: new Date().toISOString(),
          notes: notes || null,
          delivery_status: 'delivered'
        }]);
      
      if (txError) throw txError;
    }
  }
};
